import React, { useState } from "react";
import { motion } from "framer-motion";
import { useAuth } from "../../contexts/AuthContext";
import { FaEnvelope } from "react-icons/fa";

const ForgotPassword = ({ onBackToLogin }) => {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setIsLoading(true);
    try {
      await resetPassword(email);
      setMessage(
        "Password reset email sent! Please check your inbox (and spam folder)."
      );
    } catch (err) {
      setError(
        err?.message || "Failed to send reset email. Please try again later."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <motion.div
      className="auth-card"
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.1, duration: 0.5 }}
    >
      <div className="auth-header">
        <motion.h2
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
        >
          Forgot Password
        </motion.h2>
        <p>Enter your email to receive a password reset link</p>
      </div>
      {message && (
        <motion.div className="auth-success" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }}>
          {message}
        </motion.div>
      )}
      {error && (
        <motion.div className="auth-error" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }}>
          {error}
        </motion.div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <FaEnvelope className="input-icon" />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <motion.button
          type="submit"
          className="auth-button"
          disabled={isLoading}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.98 }}
        >
          {isLoading ? "Sending..." : "Send Reset Link"}
        </motion.button>
      </form>
      <div className="auth-footer">
        <motion.button
          type="button"
          className="auth-button secondary"
          style={{ background: 'transparent', color: '#3498db', border: '2px solid #3498db', marginTop: '1rem' }}
          whileHover={{ scale: 1.03, backgroundColor: '#eaf6fb' }}
          whileTap={{ scale: 0.98 }}
          onClick={onBackToLogin}
        >
          Back to Login
        </motion.button>
      </div>
    </motion.div>
  );
};

export default ForgotPassword;
